/* eslint-disable no-undef */
// @ts-nocheck
/**
 * LS Auto ALT Text System (Ultra-Lightweight)
 * Only processes images that truly need ALT text
 * Minimal impact on main thread
 */

(function() {
  'use strict';

  var processed = false;
  var pageFallback = null;

  function getPageFallback() {
    if (pageFallback) return pageFallback;
    var ctx = window.pageContext || {};
    var template = (ctx.template || '').toLowerCase();

    if (template.indexOf('product') > -1 && ctx.productTitle) {
      pageFallback = 'Image of ' + ctx.productTitle;
    } else if (template.indexOf('collection') > -1 && ctx.collectionTitle) {
      pageFallback = 'Collection image for ' + ctx.collectionTitle;
    } else if (template.indexOf('article') > -1 && ctx.articleTitle) {
      pageFallback = 'Article image for ' + ctx.articleTitle;
    } else if (template === 'index') {
      pageFallback = 'Homepage image';
    } else {
      pageFallback = 'Image';
    }
    return pageFallback;
  }

  function processImages() {
    // Only select images that truly need processing (no alt or empty alt)
    var images = document.querySelectorAll('img:not([alt]), img[alt=""]');
    if (images.length === 0) return;

    var fallback = getPageFallback();

    for (var i = 0; i < images.length; i++) {
      var img = images[i];

      // Skip decorative images
      if (img.getAttribute('role') === 'presentation' || img.getAttribute('aria-hidden') === 'true') {
        continue;
      }

      // Try to get ALT from data attribute or parent
      var newAlt = img.getAttribute('data-alt');

      if (!newAlt) {
        var parent = img.closest('[data-product-title]');
        if (parent) {
          newAlt = 'Image of ' + parent.getAttribute('data-product-title');
        }
      }

      img.setAttribute('alt', newAlt || fallback);
    }
  }

  function init() {
    if (processed) return;
    processed = true;

    // Run once after a delay - no continuous observers
    if (window.requestIdleCallback) {
      requestIdleCallback(processImages, { timeout: 3000 });
    } else {
      setTimeout(processImages, 2000);
    }

    // Only listen for Shopify section loads (theme editor)
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function() {
        setTimeout(processImages, 300);
      });
    }
  }

  // Start very late to not impact initial render
  if (document.readyState === 'complete') {
    setTimeout(init, 500);
  } else {
    window.addEventListener('load', function() {
      setTimeout(init, 500);
    });
  }

})();
